import { useNavigate, useParams } from "react-router-dom";
import { useRef } from "react";
import { useServices } from "../../services/Services";
import EventContent from "../../components/EventContent/EventContent";
import { EntityType } from "../../common-types/Entity";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import {
  ShareDialog,
  ShareDialogHandle,
} from "../../components/ShareDialog/ShareDialog";
import {
  SharedToLinkedInToast,
  SharedToLinkedInToastHandle,
} from "../../components/SharedToLinkedInToast/SharedToLinkedInToast";
import { Osdk } from "@osdk/client";
import { Analysis } from "@unruly-osdk/sdk";

const EventPage: React.FC = () => {
  const services = useServices();
  const navigate = useNavigate();
  const shareDialogRef = useRef<ShareDialogHandle>(null);
  const toastRef = useRef<SharedToLinkedInToastHandle>(null);

  const { eventId } = useParams<{
    eventId: string;
    activeTab?: string;
  }>();

  const { data: user } = services.User.useGetCurrent();

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleLinkClick = (id: string, type: EntityType) => {
    if (type === "event") {
      navigate("/event/" + id);
    } else {
      console.error("Unsupported entity type link: ", type);
    }
  };

  const handleOpenAnalysis = (
    analysis: Osdk.Instance<Analysis>,
    _eventId: string,
  ) => {
    const route =
      analysis.type === "event deep dive"
        ? `/event-analysis/${analysis.id}`
        : analysis.type === "topic deep dive"
          ? `/topic-analysis/${analysis.id}`
          : "/";
    navigate(route);
  };

  const {
    data: event,
    isLoading,
    isError,
  } = services.Event.useGetEventById(eventId);

  const eventTitle = isLoading
    ? "Loading Event..."
    : event?.name || "Event Details";
  const eventDate = isLoading
    ? ""
    : event?.startDate
      ? new Date(event.startDate).toLocaleDateString()
      : "";
  useDocumentTitle(eventTitle, eventDate);

  return (
    <>
      <EventContent
        event={event}
        isEventLoading={isLoading}
        fetchContextFromAPI={true}
        isEventError={isError}
        isContextError={false}
        onEntityClick={handleLinkClick}
        onBackClick={handleBackClick}
        userId={user?.id}
        onOpenAnalysis={handleOpenAnalysis}
        showShareDialog={(eventId) => shareDialogRef.current?.show(eventId)}
      />
      <ShareDialog
        onShareSuccess={(postId) => toastRef.current?.shareSuccess(postId)}
        ref={shareDialogRef}
      />
      <SharedToLinkedInToast ref={toastRef} />
    </>
  );
};

export default EventPage;
